import React, { useState } from "react";
import GoogleFormWrapper from "../../../../../../shared_components/GoogleFormWrapper";
import { BsCheck2Circle } from "react-icons/bs";
import { FaClock, FaCode, FaUsers } from "react-icons/fa";


const JoinUsSection = ({ model,
    toggle,
    modelTitle,
    modelDescription,
    sessionTitle,
    success,
    onSuccess
}) => {

    const infoCards = [
        {
            id: 1,
            title: "Next Session",
            desc: "Saturday, 10 AM IST",
            icon: <FaClock size={24} />,
        },
        {
            id: 2,
            title: "Topic",
            desc: "CSS Grid Mastery",
            icon: <FaCode size={24} />,
        },
        {
            id: 3,
            title: "Seats Left",
            desc: "Unlimited (Zoom Pro)",
            icon: <FaUsers size={24} className="text-pink" />,
        },
    ];
    const reasons = [
        "I want to transition into tech career",
        "I want to enhance my coding skills",
        "I want to grow in my current tech role",
        "I want to build my own tech startup",
        "I'm curious about coding and want to learn",
        "It's required for my current/future job",
        "I want to learn coding as a hobby",
        "I'm a student looking to start my tech journey",
        "Other",
    ];


    return (
        <section className="row mx-0 justify-content-center py-5 bg-light">
            <div className="col-12 col-md-10">
                <div className="row mx-0 justify-content-center text-center mb-2">
                    <div className="col-12 col-md-8">
                        <h1 className="fw-bold">Ready to Join Us?</h1>
                        <p> No credit card. No commitments. Just show up on the weekend and let’s learn together.</p>
                    </div>
                </div>

                <div className="row mx-0 justify-content-center mb-4">
                    <div className="col-12 col-md-8 px-0">
                        <div className="bg-light p-4 p-md-5">
                            <div className="modal-form border radius-10 p-3">
                                <div className="text-center">
                                    <>
                                        {success ? (
                                            <div className="text-center border p-5 rounded-lg">
                                                <BsCheck2Circle className="mb-5 text-success" size={100} />
                                                <div className="alert alert-success" role="alert">
                                                    Thank you! We'll get back to you shortly.
                                                </div>
                                            </div>
                                        ) :
                                            <GoogleFormWrapper
                                                fields={[
                                                    {
                                                        label: 'Your Name',
                                                        name: 'entry.578351606',
                                                        fieldName: 'name',
                                                        placeholder: 'Enter your name',
                                                        required: true,
                                                        type: 'text',
                                                    },
                                                    {
                                                        label: 'Your Email',
                                                        name: 'entry.826426055',
                                                        fieldName: 'email',
                                                        placeholder: 'Enter your email',
                                                        required: true,
                                                        type: 'email',
                                                    },
                                                    {
                                                        label: 'Your Phone Number',
                                                        name: 'entry.1554792534',
                                                        fieldName: 'phone',
                                                        placeholder: 'Enter your phone number',
                                                        required: true,
                                                        type: 'text',
                                                    },
                                                    {
                                                        label: 'Your Gender',
                                                        name: 'entry.978076410',
                                                        fieldName: "gender",
                                                        options: ['Male', 'Female', 'Other'],
                                                        required: true,
                                                        type: 'radio',
                                                    },
                                                    {
                                                        label: 'Your College',
                                                        name: 'entry.2121190026',
                                                        fieldName: 'college',
                                                        placeholder: 'Enter your College',
                                                        required: true,
                                                        type: 'text',
                                                    },
                                                    {
                                                        label: 'Preferred Class',
                                                        name: 'entry.1574793469', // Replace with actual Google Form entry ID
                                                        fieldName: 'preferredClass',
                                                        placeholder: `${sessionTitle?.heading} - ${sessionTitle?.time}`,
                                                        required: false,
                                                        type: 'text',
                                                        disabled: true,
                                                    },
                                                    {
                                                        label: 'Passout Year',
                                                        name: 'entry.1741450239',
                                                        fieldName: 'passoutYear',
                                                        placeholder: 'Enter your Batch',
                                                        required: true,
                                                        type: 'text',
                                                    },
                                                    {
                                                        label: 'Why do you want to join this free code class?',
                                                        name: 'entry.619625282',
                                                        fieldName: 'reason',
                                                        placeholder: 'Write your reason',
                                                        required: true,
                                                        type: 'text',
                                                    },
                                                ]}
                                                btnName="Book Now"
                                                formId="1FAIpQLScSP20Wjc4KnIsUFoFWDkn9OrHbKXzi8k1snxpc_g6qWkguQw"
                                                redirectToWhatsApp={true}
                                                whatsappNumber="7400898402"
                                                defaultFields={{
                                                    "entry.1574793469": `${sessionTitle?.heading} - ${sessionTitle?.time}`,
                                                    "entry.2001895594": `Not Joined`
                                                }}
                                                onSuccess={onSuccess}
                                                toggleModal={toggle}
                                            />
                                        }
                                    </>
                                </div>
                            </div>

                            <p className="text-center text-muted small mt-3 mb-0">
                                You’ll receive the session link and calendar invite via email. No spam, promise.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row mx-0 g-3 justify-content-center mt-4">
                    {infoCards.map((item) => (
                        <div className="col-12 col-md-4" key={item.id}>
                            <div className="p-3 h-100 text-center border radius-10">
                                <div className="mb-2 text-custom">{item.icon}</div>
                                <h6 className="fw-bold mb-2">{item.title}</h6>
                                <p className="small text-muted mb-0">{item.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default JoinUsSection;
